import {signal} from "@preact/signals-react";

export const marketplacesLBBOverviewIsEmpty = signal(false)
export const elementsInLoading = signal([])

export const resetMarketplacesLostBuyBoxOverviewSignal = () => {
    marketplacesLBBOverviewIsEmpty.value = false
    elementsInLoading.value = []
}